import type { ReactNode } from 'react';

import { cn } from '@/utils/classname';

// SectionIntro is the top-of-step heading + lead paragraph each wizard step
// opens with. Keeps copy density consistent across all five steps.
export function SectionIntro({
  title,
  body,
}: {
  title: string;
  body: ReactNode;
}) {
  return (
    <div className="space-y-2">
      <h3 className="text-chariot-text-primary text-lg font-bold">{title}</h3>
      <div className="text-chariot-text-primary space-y-2 text-sm">{body}</div>
    </div>
  );
}

// Field is a label + control wrapper used wherever a shadcn primitive
// (Select / Textarea) needs a label without pulling in the full
// react-hook-form + zod stack. For text inputs use <Input label="..."/>.
export function Field({
  label,
  children,
  hint,
  className,
}: {
  label: string;
  children: ReactNode;
  hint?: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <label className="text-chariot-text-primary mb-2 block text-sm font-medium">
        {label}
      </label>
      {children}
      {hint && (
        <p className={cn('text-chariot-text-secondary mt-1 text-xs')}>{hint}</p>
      )}
    </div>
  );
}
